const initialState = {
  uid: "",
};

const UserIdReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_USER_ID":
      return {
        ...state,
        uid: action.payload,
      };
    default:
      return state;
  }
};

export default UserIdReducer;
